import React from 'react';
import StatusContext from '../../../contexts/StatusContext'
import Button from '@mui/material/Button';

import "./pushbutton.css"

export const PushButton = ({label, onClick, disablebutton, height, color, colorback}) => {


  let {
    isLoading,
  } = React.useContext(StatusContext);

  

  return (
       
    <div>
      <Button
        variant="contained"
        size = "small"
        sx={{ height: height || '3ch', fontStyle:'italic', fontSize: '12px', color: color, backgroundColor: colorback}}
        onClick={onClick}
        disabled = {isLoading || disablebutton}
        >
         {label}
      </Button>
    </div>
     
  );
};

PushButton.defaultProps = {
  disablebutton: false,
  color: 'white',
  colorback: 'rgb(59, 75, 93)'
}
